/**
 * 加载态（骨架屏）
 */
interface LoadingProps {
  rows?: number;
  type?: 'card' | 'list' | 'skeleton';
  text?: string;
}

function SkeletonCard() {
  return (
    <div className="card loading-card">
      <div className="skeleton" style={{ height: 180, borderRadius: 'var(--radius-lg) var(--radius-lg) 0 0' }} />
      <div style={{ padding: 16 }}>
        <div className="skeleton" style={{ height: 18, width: '60%', marginBottom: 12 }} />
        <div className="skeleton" style={{ height: 14, width: '85%', marginBottom: 8 }} />
        <div className="skeleton" style={{ height: 14, width: '45%' }} />
      </div>
    </div>
  );
}

function SkeletonRow() {
  return (
    <div className="card loading-row">
      <div className="skeleton" style={{ width: 92, height: 92, borderRadius: 8, flexShrink: 0 }} />
      <div style={{ flex: 1 }}>
        <div className="skeleton" style={{ height: 18, width: '38%', marginBottom: 12 }} />
        <div className="skeleton" style={{ height: 14, width: '70%', marginBottom: 8 }} />
        <div className="skeleton" style={{ height: 14, width: '50%' }} />
      </div>
    </div>
  );
}

export default function Loading({ rows = 4, type = 'card', text }: LoadingProps) {
  if (type === 'skeleton') {
    return (
      <div className="loading-wrap">
        <div className="spinner" style={{ margin: '0 auto' }} />
        {text ? <p style={{ textAlign: 'center', marginTop: 12, color: 'var(--color-ink-secondary)', fontSize: 13 }}>{text}</p> : null}
      </div>
    );
  }

  return (
    <div className={type === 'card' ? 'loading-grid' : 'loading-list'}>
      {Array.from({ length: rows }, (_, i) => (type === 'card' ? <SkeletonCard key={i} /> : <SkeletonRow key={i} />))}
    </div>
  );
}
